import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { MotivoPerdaVendaOportunidadeFormComponent } from './motivo-perda-venda-oportunidade-form.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        MotivoPerdaVendaOportunidadeFormComponent
    ],
    exports: [
        MotivoPerdaVendaOportunidadeFormComponent
    ]
})
export class MotivoPerdaVendaOportunidadeFormModule { }
